import { Fragment, useState, useEffect } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import Swal from 'sweetalert2';


export default function ShoppingCarts(props){
    

    const [open, setOpen] = useState(props.isOpen)
    const [products, setProducts] = useState([])

    // useEffect(() => {
    //     setOpen(props.isOpen)
    // }, [props.isOpen]);

    useEffect(()=>{
        setOpen(props.isOpen)
        const storeProductos = JSON.parse(localStorage.getItem('Registrados'));
        if(storeProductos){
            setProducts(storeProductos);
        }
      }
    ,[props.isOpen])

    const eliminarProducto=(id)=>{
      Swal.fire({
          title: 'Estas segura/o?',
          text: "",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, eliminar!'
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire(
              'Eliminado!',
              'Su articulo a sido eliminado.',
              'success'
            )
              const newList = products.filter((e, index) => index !== id);
              setProducts(newList)
              localStorage.setItem('Registrados', JSON.stringify(newList))
          }else if(result.dismiss){
              Swal.fire(
                  'Cancelado',
                  'Tu articulo está a salvo :)',
                  'error'
              )
          }
      })
    }

    let total=0;

    const sumall = products.map(item => item.Price);
    sumall.forEach(function(a){total+=a;});

    const nuevoPrecio = Number(total);

    return (
        <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={setOpen}>
            <Transition.Child
              as={Fragment}
              enter="ease-in-out duration-500"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in-out duration-500"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
    
            <div className="fixed inset-0 overflow-hidden">
              <div className="absolute inset-0 overflow-hidden">
                <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                  <Transition.Child
                    as={Fragment}
                    enter="transform transition ease-in-out duration-500 sm:duration-700"
                    enterFrom="translate-x-full"
                    enterTo="translate-x-0"
                    leave="transform transition ease-in-out duration-500 sm:duration-700"
                    leaveFrom="translate-x-0"
                    leaveTo="translate-x-full"
                  >
                    <Dialog.Panel className="pointer-events-auto z-50 w-screen max-w-md">
                      <div className="flex h-full z-50 flex-col overflow-y-scroll bg-white shadow-xl">
                        <div className="flex-1 overflow-y-auto px-4 py-6 sm:px-6">
                          <div className="flex items-start justify-between">
                            <Dialog.Title className="text-lg font-medium text-gray-900">Mi Carrito</Dialog.Title>
                            <div className="ml-3 flex h-7 items-center">
                              <button
                                type="button"
                                className="relative -m-2 p-2 text-gray-400 hover:text-gray-500"
                                onClick={() => setOpen(false)}
                              >
                                <span className="absolute -inset-0.5" />
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                              </button>
                            </div>
                          </div>
    
                          <div className="mt-8">
                            <div className="flow-root">
                              <ul role="list" className="-my-6 divide-y divide-gray-200">
                                {products.map((product, index) => (
                                  <li key={+1} className="flex py-6">
                                    <div className="h-24 w-24 flex-shrink-0 overflow-hidden rounded-md border border-gray-200">
                                      <img
                                        src={product.Image}
                                        className="h-full w-full object-cover"
                                      />
                                    </div>
    
                                    <div className="ml-4 flex flex-1 flex-col">
                                      <div>
                                        <div className="flex justify-between text-base font-medium text-gray-900">
                                          <h3>
                                            <a href=''>{product.Title}</a>
                                          </h3>
                                          <p className="ml-4">${product.Price}</p>
                                        </div>
                                        <p className="mt-1 text-sm text-gray-500">Black/None</p>
                                      </div>
                                      <div className="flex flex-1 items-end justify-between text-sm">
                                        <p className="text-gray-500">Qty {product.Quantity}</p>
    
                                        <div className="flex">
                                          <button
                                            type="button"
                                            className="font-medium text-red-600 hover:text-red-500"
                                            onClick={()=> eliminarProducto(index)}
                                          >
                                            Eliminar
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
    
                        <div className="border-t border-gray-200 px-4 py-6 sm:px-6">
                          <div className="flex justify-between text-base font-medium text-gray-900">
                            <p>Subtotal</p>
                            <p>${nuevoPrecio}.00</p>
                          </div>
                          <p className="mt-0.5 text-sm text-gray-500">Envío e impuestos calculados al finalizar la compra..</p>
                          <div className="mt-6">
                            <a
                              href="/midireccion"
                              className="flex items-center justify-center rounded-md border border-transparent bg-[#fb8cff] px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-[#f66efb]"
                            >
                              Continuar al Checkout
                            </a>
                          </div>
                          <div className="mt-6 flex justify-center text-center text-sm text-gray-500">
                            <p>
                              o
                              <button
                                type="button"
                                className="font-medium ml-1 text-[#fb8cff] hover:text-[#f66efb]"
                                onClick={() => setOpen(false)}
                              >
                                Seguir Comprando
                                <span aria-hidden="true"> &rarr;</span>
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
    )

}